import { Fragment, useEffect, useMemo, useState } from "react"
import { MainContainer } from "../../components"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { calculateTotalByKey, selectFilter, stickyParentClass } from "../../Utility/utility"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import jsPDF from "jspdf"
import { autoTable } from "jspdf-autotable"
import { useNavigate } from "react-router-dom"
import { resetStockLotno, setStockLotno } from "../../state/stockEntrySlice"
import { Button, Chip, Input } from "@heroui/react"
import { cond } from "lodash"
import { ConsoleView } from "react-device-detect"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons"

const SinglePktInwardReport = () => {
    const { compCode, compName } = useSelector((state) => state.company);
    const { stockLotNo } = useSelector((state) => state.stockEntry);
    const [searchText, setSearchText] = useState("")
    const navigate = useNavigate();
    const dispatch = useDispatch();
    console.log(stockLotNo)
    const [inwardDate, setInwardDate] = useState({
        fromDate: stockLotNo?.filters?.fromDate || null,
        toDate: stockLotNo?.filters?.toDate || null

    });
    const { data:inwData = [], mutate: filterData } = usePost({
        url: apiRoute.stockEntry.fetchInwardData,
        queryKey: "lotwiseDetailtck"
    });

    const funFilterData = (fdate, tdate) => {
        console.log(fdate, tdate)
        filterData({
            data: {
                comp_code: compCode.join(","),
                trade_of: "P",
                from_date: fdate,
                to_date: tdate
            }
        });
    }
    useEffect(() => {
        funFilterData(inwardDate.fromDate, inwardDate.toDate);
    }, [])
    const handleFilter = () => {
        if ((inwardDate.fromDate && inwardDate.fromDate == 'Invalid Date')
            || (inwardDate.toDate && inwardDate.toDate == 'Invalid Date')) {
            toast.error("Invalid From Date / To Date", {
                "position": "top-center"
            })
            return;
        }
        funFilterData(inwardDate.fromDate, inwardDate.toDate);

    }

    const data = useMemo(() => {
        if (!searchText) return inwData;

        const lowerSearch = searchText.toLowerCase();

        return inwData.filter(item =>
            Object.values(item).some(val =>
                val !== null &&
                val !== undefined &&
                val.toString().toLowerCase().includes(lowerSearch)
            )
        );
    }, [inwData, searchText]);

    const handleDetail = (lotno) => {
        const obj = { filters: { ...inwardDate }, lotnos: [String(lotno)], isInward: 1 }
        dispatch(setStockLotno(obj))
        navigate(linksUrl.rptSinglePktLotWiseStockDetail)

    }
    const handleClear = () => {
        setInwardDate({ fromDate: null, toDate: null })
        dispatch(resetStockLotno())
        funFilterData(null, null);

    }



    const totals = data.reduce(
        (acc, r) => {
            acc.Inw_Wt += r.Inw_Wt;
            acc.Inw_Pcs += r.Inw_Pcs;
            acc.Stk_Wt += r.Stk_Wt;
            acc.Stk_Pcs += r.Stk_Pcs;
            acc.Sale_Wt += r.Sale_Wt;
            acc.Sale_Pcs += r.Sale_Pcs;
            return acc;
        },
        { Inw_Wt: 0, Inw_Pcs: 0, Stk_Wt: 0, Stk_Pcs: 0, Sale_Wt: 0, Sale_Pcs: 0 }
    );
    const tblHeadClas = 'border-1 text-xs border-gray-500  px-3 py-2 text-center uppercase leading-tight'
    const tbltdClass = 'border-1 text-sm border-gray-300  px-3 py-2 text-right uppercase leading-tight'
    const tblfootdClass = 'border-1 text-sm border-gray-500 font-bold  px-3 py-2 text-right uppercase leading-tight'
    const StickyLeftCell = "sticky  text-center bg-gray-50 uppercase left-0 z-20 border-r-2 border-1 leading-tight border-slate-500 bg-gradient-to-r from-yellgow-100 to-yelglow-50";



    const exportToPDF = () => {
        if (!data || data.length === 0) return;

        const doc = new jsPDF("p", "mm", "a4");

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const companyName = compName.join(", ");
        const reportTitle = "SINGLE PACKET LOT WISE INWARD STOCK POSITION";
        const today = new Date().toLocaleDateString("en-GB");
        const dateText =
            inwardDate.fromDate || inwardDate.toDate
                ? `Date From : ${inwardDate.fromDate ?? "-"}   To : ${inwardDate.toDate ?? "-"}`
                : "";

        /* ================= TABLE HEADERS ================= */

        const headRow1 = [
            { content: "Lot No", rowSpan: 2, styles: { halign: "center" } },
            { content: "Inward", colSpan: 2 },
            { content: "Sale", colSpan: 2 },
            { content: "Stock", colSpan: 2 }
        ];

        const headRow2 = [
            { content: "Pcs" },
            { content: "Weight" },
            { content: "Pcs" },
            { content: "Weight" },
            { content: "Pcs" },
            { content: "Weight" }

        ];

        /* ================= BODY ================= */

        const body = data.map(r => ([
            r.sl_code,
            r.Inw_Pcs,
            r.Inw_Wt.toFixed(2),
            r.Sale_Pcs,
            r.Sale_Wt.toFixed(2),
            r.Stk_Pcs,
            r.Stk_Wt.toFixed(2)

        ]));

        /* ================= FOOT TOTAL ================= */

        const foot = [[
            "Total",
            totals.Inw_Pcs,
            totals.Inw_Wt.toFixed(2),
            totals.Sale_Pcs,
            totals.Sale_Wt.toFixed(2),
            totals.Stk_Pcs,
            totals.Stk_Wt.toFixed(2)

        ]];

        /* ================= TABLE ================= */

        autoTable(doc, {
            startY: 26, // space for page header
            head: [headRow1, headRow2],
            body,
            foot,

            theme: "grid",

            styles: {
                fontSize: 8,
                halign: "right",
                valign: "middle",
                lineWidth: 0.1
            },

            headStyles: {
                fillColor: [240, 240, 240],
                textColor: 0,
                fontStyle: "bold",
                halign: "center"
            },

            footStyles: {
                fillColor: [230, 230, 230],
                textColor: 0,
                fontStyle: "bold",
                halign: "right"
            },

            columnStyles: {
                0: { halign: "center", cellWidth: 22 }
            },

            margin: { top: 26, left: 8, right: 8, bottom: 12 },

            didDrawPage: () => {
                /* ================= HEADER ================= */
                doc.setFont("helvetica", "bold");
                doc.setFontSize(13);
                doc.text(companyName, pageWidth / 2, 10, { align: "center" });

                doc.setFontSize(10);
                doc.text(`${reportTitle} (${dateText})`, pageWidth / 2, 16, { align: "center" });

                doc.setFont("helvetica", "normal");
                doc.setFontSize(9);
                doc.text(`Date : ${today}`, pageWidth - 10, 10, { align: "right" });

                /* ================= FOOTER ================= */
                doc.setFontSize(8);
                doc.text(
                    `Generated on : ${new Date().toLocaleString()}`,
                    pageWidth - 10,
                    pageHeight - 5,
                    { align: "right" }
                );
            }
        });

        doc.save("Single_Packet_Lot_Wise_Inward_Stock.pdf");
    };


    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Inward Stock");

        const lotFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FEE2E2" } };
        const inwardFill = { type: "pattern", pattern: "solid", fgColor: { argb: "E3F2FD" } }; // light blue
        const saleFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3E0" } }; // light orange
        const stockFill = { type: "pattern", pattern: "solid", fgColor: { argb: "E8F5E9" } }; // light green

        let currentRow = 1;

        /* ================= COMPANY NAME ================= */
        worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
        worksheet.getCell(`A${currentRow}`).value = compName.join(", ");
        worksheet.getCell(`A${currentRow}`).font = {
            bold: true,
            size: 14
        };
        worksheet.getCell(`A${currentRow}`).alignment = {
            horizontal: "center",
            vertical: "middle"
        };
        currentRow++;

        /* ================= REPORT NAME ================= */
        const reportTitle = "Single Packet Lot Wise Inward Stock Position"; // or dynamic
        const today = new Date().toLocaleDateString("en-GB");

        worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
        worksheet.getCell(`A${currentRow}`).value =
            `${reportTitle} - (${today})`
        worksheet.getCell(`A${currentRow}`).font = {
            bold: true,
            size: 12
        };
        worksheet.getCell(`A${currentRow}`).alignment = {
            horizontal: "center"
        };
        currentRow++;

        /* ================= DATE RANGE ================= */
        const dateText =
            // inwardDate.fromDate || inwardDate.toDate
            `From Date : ${inwardDate.fromDate ?? "-"}   To Date : ${inwardDate.toDate ?? "-"}`
        // : "";

        worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
        worksheet.getCell(`A${currentRow}`).value = dateText;
        worksheet.getCell(`A${currentRow}`).alignment = {
            horizontal: "center"
        };
        worksheet.getCell(`A${currentRow}`).font = {
            bold: true,
            size: 12
        };
        currentRow += 2;

        /* ================= TABLE HEADER ================= */

        worksheet.mergeCells(`A${currentRow}:A${currentRow + 1}`);
        worksheet.mergeCells(`B${currentRow}:C${currentRow}`);
        worksheet.mergeCells(`D${currentRow}:E${currentRow}`);
        worksheet.mergeCells(`F${currentRow}:G${currentRow}`);

        worksheet.getRow(currentRow).values = [
            "Lot No",
            "Inward",
            "",
            "Sale",
            "",
            "Stock",
            ""
        ];

        worksheet.getRow(currentRow + 1).values = [
            "",

            "Pcs",
            "Weight",
            "Pcs",
            "Weight",
            "Pcs",
            "Weight"
        ];

        const headerStyle = {
            alignment: { horizontal: "center", vertical: "middle" },
            font: { bold: true },
            border: {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            }
        };

        [currentRow, currentRow + 1].forEach(rowNo => {
            worksheet.getRow(rowNo).eachCell((cell, colNumber) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = headerStyle.border;

                // 🎯 Column-wise color mapping (same as data)
                if (colNumber === 1) cell.fill = lotFill;
                if (colNumber === 2 || colNumber === 3) cell.fill = inwardFill;
                if (colNumber === 4 || colNumber === 5) cell.fill = saleFill;
                if (colNumber === 6 || colNumber === 7) cell.fill = stockFill;
            });
        });



        currentRow += 2;

        /* ================= DATA ROWS ================= */

        data.forEach(row => {
            const r = worksheet.addRow([
                row.sl_code,
                row.Inw_Pcs,
                row.Inw_Wt,
                row.Sale_Pcs,
                row.Sale_Wt,
                row.Stk_Pcs,
                row.Stk_Wt

            ]);

            r.eachCell((cell, colNumber) => {
                cell.border = headerStyle.border;
                cell.alignment = {
                    horizontal: colNumber === 1 ? "center" : "right"
                };

                if ([2, 4, 6].includes(colNumber)) {
                    cell.numFmt = "0.00";
                }

                if (colNumber === 1) {
                    cell.fill = lotFill;
                }
                if (colNumber === 2 || colNumber === 3) {
                    cell.fill = inwardFill;
                }
                if (colNumber === 4 || colNumber === 5) {
                    cell.fill = saleFill;
                }
                if (colNumber === 6 || colNumber === 7) {
                    cell.fill = stockFill;
                }
            });
        });



        /* ================= TOTAL ROW ================= */

        const totalRow = worksheet.addRow([
            "Total",
            totals.Inw_Pcs,
            totals.Inw_Wt,
            totals.Sale_Pcs,
            totals.Sale_Wt,
            totals.Stk_Pcs,
            totals.Stk_Wt

        ]);

        totalRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true };
            cell.border = headerStyle.border;
            cell.alignment = {
                horizontal: colNumber === 1 ? "center" : "right"
            };

            if ([2, 4, 6].includes(colNumber)) {
                cell.numFmt = "0.00";
            }

            if (colNumber === 1) {
                cell.fill = lotFill;
            }
            if (colNumber === 2 || colNumber === 3) {
                cell.fill = inwardFill;
            }
            if (colNumber === 4 || colNumber === 5) {
                cell.fill = saleFill;
            }
            if (colNumber === 6 || colNumber === 7) {
                cell.fill = stockFill;
            }
        });


        /* ================= COLUMN WIDTH ================= */

        worksheet.columns = [
            { width: 15 },
            { width: 12 },
            { width: 10 },
            { width: 12 },
            { width: 10 },
            { width: 12 },
            { width: 10 }
        ];

        /* ================= FREEZE HEADER ================= */
        worksheet.views = [
            { state: "frozen", ySplit: currentRow }
        ];

        /* ================= DOWNLOAD ================= */

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            "Single_Packet_Lot_Wise_Inward_Stock.xlsx"
        );
    };


    return (
        <MainContainer
            pageName="Single Packet Lot Wise Inward Stock Report"
            breadcrumbs={["Reports", "Single Packet Lot Wise Inward Stock Report"]}
        >
            <div className="bg-white p-2 h-screen">

                <div className="p-2 shadow mb-5">
                    {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                    <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                         <div className="flex no-wrap gap-5">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={"From Date"}
                                views={["day", "month", "year"]}
                                size="small"
                                format="DD/MM/YYYY"
                                value={
                                    inwardDate.fromDate
                                        ? dayjs(inwardDate.fromDate)
                                        : inwardDate.fromDate
                                }
                                onChange={(newValue) => {
                                    setInwardDate((prev) => {
                                        return {
                                            ...prev,
                                            fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                dayjs(newValue).format("YYYY-MM-DD") : null,
                                        };
                                    });
                                }}
                                slotProps={{
                                    textField: { size: "small", },
                                }}
                            />
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={"To  Date"}
                                views={["day", "month", "year"]}
                                format="DD/MM/YYYY"
                                size="small"
                                value={
                                    inwardDate.toDate
                                        ? dayjs(inwardDate.toDate)
                                        : inwardDate.toDate
                                }
                                onChange={(newValue) => {
                                    setInwardDate((prev) => {
                                        return {
                                            ...prev,
                                            toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                dayjs(newValue).format("YYYY-MM-DD") : null,
                                        };
                                    });
                                }}
                                slotProps={{
                                    textField: { size: "small", },
                                }}
                            />
                        </LocalizationProvider>
                        </div>
                        <div className="flex no-wrap gap-5 justify-center items-center">
                        <Button onPress={handleFilter} className="font-semibold uppercase bg-slate-700 text-white" variant="solid" color="primary" size="sm" >Get Stock</Button>
                        <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Clear Date</Button>
                        </div>
                    </div>
                </div>
                <div className="flex justify-between">
                    <h2 className="text-red-600  uppercase text-xs  font-semibold text-sm">Total Records : {data?.length || 0}</h2>
                    <div className="flex justify-end mb-2 gap-4">
                        <button
                            onClick={exportToExcel}
                            className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
                        >
                            Export Excel
                        </button>
                        <button
                            onClick={exportToPDF}
                            className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-green-700"
                        >
                            Export PDF
                        </button>
                    </div>
                </div>
 <Input type="text" size="sm"
                        radius="none" placeholder="Search ...."
                        startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                        variant="bordered" className="bg-white border-0  border-gray-300"
                        value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                <div className="overflow-auto max-h-[70vh] border-1 border-slate-300 ">
                    <table className="min-w-full  border-separate border-spacing-0 text-sm">
                        {/* Header */}
                         <thead className="sticky top-0 z-40 bg-white shadow-sm">
                            <tr className="">
                                <th rowSpan="2" className={` ${StickyLeftCell}`}>
                                    Lot No
                                </th>
                                <th colSpan="2" className={` bg-cyan-50 ${tblHeadClas}`}>
                                    Inward
                                </th>
                                <th colSpan="2" className={` bg-red-50 ${tblHeadClas}`}>
                                    Sale
                                </th>
                                <th colSpan="2" className={` bg-orange-50 ${tblHeadClas}`}>
                                    Stock
                                </th>
                            </tr>
                            <tr className="bg-white sticky  top-[33px] z-30">

                                <th className={`${tblHeadClas}`}>Pcs</th>
                                <th className={`${tblHeadClas}`}>Weight</th>

                                <th className={`${tblHeadClas}`}>Pcs</th>
                                <th className={`${tblHeadClas}`}>Weight</th>

                                <th className={`${tblHeadClas}`}>Pcs</th>
                                <th className={`${tblHeadClas}`}>Weight</th>
                            </tr>
                        </thead>

                        {/* Body */}
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.sl_code} className="hover:bg-gray-50">
                                    <td className={` bg-gray-50 ${StickyLeftCell}`}>
                                        <Chip onClick={() => handleDetail(row.sl_code)} className=" bg-pink-50 text-pink-600 font-semibold  cursor-pointer p-2" variant="flat" color="dandger" >   {row.sl_code}  </Chip>
                                    </td>
                                    <td className={` bg-cyan-50 ${tbltdClass}`}>{row.Inw_Pcs}</td>
                                    <td className={` bg-cyan-50 ${tbltdClass}`}>{row.Inw_Wt.toFixed(2)}</td>
                                    <td className={` bg-red-50 ${tbltdClass}`}>{row.Sale_Pcs}</td>
                                    <td className={` bg-red-50 ${tbltdClass}`}>{row.Sale_Wt.toFixed(2)}</td>
                                    <td className={` bg-orange-50 ${tbltdClass}`}>{row.Stk_Pcs}</td>
                                    <td className={` bg-orange-50 ${tbltdClass}`}>{row.Stk_Wt.toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>

                        {/* Footer */}
                        <tfoot className="sticky bottom-0 z-20 bg-white h-7 font-semibold">
                            <tr>
                                <td className={` ${tblfootdClass} text-center`}>Total</td>
                                <td className={` ${tblfootdClass} text-cyan-700  `}>{totals.Inw_Pcs}</td>
                                <td className={` ${tblfootdClass} text-cyan-700   `}>{totals.Inw_Wt.toFixed(2)}</td>
                                <td className={` ${tblfootdClass} text-red-700  `}>{totals.Sale_Pcs}</td>
                                <td className={` ${tblfootdClass} text-red-700   `}>{totals.Sale_Wt.toFixed(2)}</td>
                                <td className={` ${tblfootdClass} text-orange-700 `}>{totals.Stk_Pcs}</td>
                                <td className={` ${tblfootdClass} text-orange-700  `}>{totals.Stk_Wt.toFixed(2)}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </MainContainer>
    );
};

export default SinglePktInwardReport;
